import { User } from '../../types/User';
import { useAppSelector } from '../hooks/ReduxHooks';

export const useAuthenticatedUser = (): User | null => {
  return useAppSelector<User | null>((store) => store.auth.authenticatedUser);
};
